import React from 'react';
import './Form.scss';
import { onSubmit } from '../../../util/onSubmit';
import { HUBSPOT_FORM_CONFIG } from '../../../constants/hubspotFormConfig';

/**
 * Renders a form
 * @param {function} handleSubmit
 * @param rows
 * @param formUrl
 * @param setFormComplete
 * @param setStatus
 * @returns {JSX.Element}
 * @constructor
 */
const Form = ({ handleSubmit, rows, guid, setFormComplete, setStatus }) => {
  const formHandler = async (data, e) => {
    try {
      e.preventDefault();
      const url = `${HUBSPOT_FORM_CONFIG.FORM_URL}/${HUBSPOT_FORM_CONFIG.HUBSPOT_ID}/${guid}`;
      await onSubmit(url, data, callbacks);
    } catch (error) {
      throw new Error(error);
    }
  };

  const callbacks = {
    onError: () => {
      setStatus('error');
    },
    onSuccess: () => {
      setFormComplete(true);
    },
  };

  return (
    <form className="c-form background-color-white" onSubmit={handleSubmit(formHandler)}>
      <div className="c-form__inner">{rows}</div>
    </form>
  );
};

export default Form;
